import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { typeFilters } from '../FiltersConstants.inner.js';

const ContainsFilter = ({
  children,
  setFilterValue,
  filterValue,
  validate = () => false,
}) => {
  const [value, setValue] = useState(filterValue);

  const hasChanges = () => filterValue !== value;

  useEffect(() => {
    hasChanges() && setValue(filterValue);
  }, [filterValue]);

  useEffect(() => {
    if (hasChanges()) {
      if (value) {
        setFilterValue({
          type: typeFilters.CONTAINS,
          value: value,
          error: validate(value),
        });
      } else {
        setFilterValue(null);
      }
    }
  }, [value]);

  return children({ setValue, value });
};

ContainsFilter.propTypes = {
  children: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func.isRequired,
};

export default ContainsFilter;
